import { plainToClass } from 'class-transformer'
import { validate } from 'class-validator'
import { ListRoundsDTO } from '../../dto/winners'
import { store } from '../../store'

export const listRounds = async ( keyword?: string ) => {

    let body: ListRoundsDTO
    let response: Response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/winners${ keyword ? `?keyword=${ keyword }` : `` }`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'get'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'LIST_ROUNDS_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'LIST_ROUNDS_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'LIST_ROUNDS_UNEXPECTEDRESPONSE' } )
        return

    }

    try {

        body = plainToClass( ListRoundsDTO, JSON.parse( await response.text() ) )

    } catch ( exception ) {

        store.dispatch( { type: 'LIST_ROUNDS_INVALIDJSON' } )
        return

    }

    if ( ( await validate( body ) ).length > 0 ) {

        store.dispatch( { type: 'LIST_ROUNDS_INVALIDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'LIST_ROUNDS_OK', years: body.years } )

}
